import React from 'react'

import Dropdown from 'components/base/Dropdown'
import DropdownItem from './Item'

const DROPDOWN_MAX_HEIGHT = 220

const PopularNamesDropDown = ({
  showHeader,
  highlightedIndex,
  options,
  onClickItem,
}) => (
  <Dropdown.Body
    placement="bottom"
    style={{
      maxHeight: DROPDOWN_MAX_HEIGHT,
      width: '100%',
    }}
    className={
      'popover position-absolute inline-block radius-normal scroll-y margin-top-smaller border-none shadow-normal'
    }
  >
    <Dropdown.Menu scrolling maxHeight={DROPDOWN_MAX_HEIGHT}>
      {showHeader && (
        <Dropdown.Header className="shade-30 font-size-smaller font-weight-medium padding-bottom-normal">
          {'POPULAR NAMES'}
        </Dropdown.Header>
      )}
      {options.map((name, index) => (
        <DropdownItem
          className="no-outline"
          key={name}
          onClick={() => onClickItem(name)}
          isHighlighted={highlightedIndex === index}
        >
          {name}
        </DropdownItem>
      ))}
    </Dropdown.Menu>
  </Dropdown.Body>
)

export default PopularNamesDropDown
